import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';

export default class FieldsetComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentFieldset | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.input = false;
		this.legend = settings?.legend ?? '';
		this.components = settings?.components
			? settings.components.map((/** @type {any} */ c) => createComponentInstance(c))
			: [];
	}
}
